/**
 * These sources are omitted for all users. They are unused sources that still exist in the backend but are not used in the frontend.
 */
const OMITTED_SOURCE_TYPES = [
    'org',
    'social',
    'space',
    'sports',
    'my_files',
    'github_delegate_bot',
    'google_docs',
    'finance_agent',
];
export function isOmittedSourceType(sourceType) {
    return OMITTED_SOURCE_TYPES.includes(sourceType);
}
//# sourceMappingURL=isOmittedSource.js.map